export const sortByAreaDisplayOrder = (masterBookSets) => {
  if (masterBookSets) {
    return masterBookSets.slice().sort(function (a, b) {
      if (
        a.reference_master_book.master_areas[0].display_order <
        b.reference_master_book.master_areas[0].display_order
      ) {
        // nullは末尾になるように
        if (a.reference_master_book.master_areas[0].display_order == null) {
          return 1;
        }
        return -1;
      }
      if (
        a.reference_master_book.master_areas[0].display_order >
        b.reference_master_book.master_areas[0].display_order
      ) {
        // nullは末尾になるように
        if (b.reference_master_book.master_areas[0].display_order == null) {
          return -1;
        }
        return 1;
      }
      return 0;
    });
  }
};
